module.exports = __webpack_public_path__ + "media/military/Military_main_callout-d9c89f79.png";